import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { DLModal } from 'appSrc/components/Shards';
import { dAPI } from 'appSrc/api';
import VanityLinkForm from './VanityLinkForm';
import LoadingOverlay from 'appSrc/components/Shards/Loading/Overlay';


class NewVanityLinkModal extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            fetching: false,
        };
    }
    submitHandler = ( values ) => {
        this.setState( { fetching: true } );
        this.props.createVanityLink( { ...values } )
        .then( ( vanityLink ) => {
            this.setState( { fetching: false } );
            this.props.onSubmit && this.props.onSubmit( vanityLink );
        } );
    }



    render() {
        return (
            <DLModal title='New Vanity URL'
            closeHandler={ this.props.closeModal }>
                <div>
                    <VanityLinkForm onSubmit={ this.submitHandler } />
                </div>
                { this.state.fetching &&
                    <LoadingOverlay />
                }
            </DLModal>
        );
    }
}
const mapDispatchToProps = () => {
    return {
        createVanityLink: ( data ) => {
            return dAPI.post( '/admin/vanity-urls', data );
        },
    };
};

export default connect( null, mapDispatchToProps )( NewVanityLinkModal );
